// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3pTbS","productName":"Table_productName__3jqFU"};